<template>
  <div id="domains" >
    <div class="wrapper">
      <div class="btnPrimary" id="subjectBtn">Domains<i class="fas fa-sort-down"></i></div>
      <div id="domainIcon" @click="showDomainMenu">
        <svg width="33px" height="auto" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="4.b-High-Resolution-Prototype---Mobile" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="xs_v1.1_1.1.A-Landing_default" transform="translate(-650.000000, -40.000000)" fill="#32344F" fill-rule="nonzero">
                  <g id="Group" transform="translate(30.000000, 40.000000)">
                      <g id="domains" transform="translate(595.000000, 0.000000)">
                          <path d="M25,0 L44.5555555,0 L44.5555555,19.5555555 L25,19.5555555 L25,0 Z M25,24.4444445 L44.5555555,24.4444445 L44.5555555,44 L25,44 L25,24.4444445 Z M49.4444445,0 L69,0 L69,19.5555555 L49.4444445,19.5555555 L49.4444445,0 Z M49.4444445,24.4444445 L69,24.4444445 L69,44 L49.4444445,44 L49.4444445,24.4444445 Z M54.3333333,4.88888887 L54.3333333,14.6666667 L64.1111111,14.6666667 L64.1111111,4.88888887 L54.3333333,4.88888887 Z M54.3333333,29.3333333 L54.3333333,39.1111111 L64.1111111,39.1111111 L64.1111111,29.3333333 L54.3333333,29.3333333 Z M29.8888889,4.88888887 L29.8888889,14.6666667 L39.6666667,14.6666667 L39.6666667,4.88888887 L29.8888889,4.88888887 Z M29.8888889,29.3333333 L29.8888889,39.1111111 L39.6666667,39.1111111 L39.6666667,29.3333333 L29.8888889,29.3333333 Z" id="Shape"></path>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
        <p class="note">Domains</p>
      </div>
    </div>
    <div id="domainmenu" ref="domainMenu">
      <!--hide domain menu on small screen-->
      <div id="back" @click="hideDomainMenu"><i class="fa fa-arrow-left"></i>Back</div>
      <router-link :to="{name:'domain', params:{domain_name:domain.name}}" target="_blank"
        class="domain"
        v-for ="domain in domains"
        :key="domain.name"
      >
        <div class="domainWrapper">
          <img class="subjectIcon" :src="require('../../assets/img/atom/icon/light/'+ domain.name.replace(/ /g, '_').replace('&', 'and').toLowerCase() + '.svg')">
<!--       <h5 @click="getDomains">{{domain.name}}</h5>-->
           <h5 @click="getDomains" style="text-transform: capitalize">{{domain.name}}</h5>
          <i class="fa fa-chevron-right"></i>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
  import {getDomains} from "../../api/api";


export default {
  name: 'IndexSubject',
  data () {
    return {
      chevron_right: require('../../assets/img/atom/icon/utility/chevron-right.svg'),
      domains: []
    }
  },
  methods: {
    // showSecondary: function(domain){
    //   this.subject=domain.domain_list;
    // },
    domainHover: function (domain) {
      for (let i = 0; i < this.domains.length; i++) {
        this.domains[i].domain_hover = false
      }
      domain.domain_hover = true
    },
    // Back-end sending domains information
    getDomainList () {
      getDomains({
        params: {}
      }).then((response)=> {
        this.domains = response.data
      })
    },
    showDomainMenu:function(){
      this.$refs.domainMenu.style.display="block"
    },
    hideDomainMenu:function(){
      this.$refs.domainMenu.style.display="none"
    }
  },
  created () {
    this.getDomainList()
  },
}

</script>



// WEBPACK FOOTER //
// src/view/General/Domains.vue